import { useLocation } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { ProductUpdatesPoliciesDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import NewLayoutContent from './_NewLayoutContent'

const ProductUpdatesPage = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const { loading, data: policies } = useQuery(ProductUpdatesPoliciesDocument)

  const canSeeSubscribeButton = policies?.modules._policies.moduleManageModule.can
  const canSeeUpsellButton = policies?.productUpdates._policies.upsellButtonSeeUpsellButton.can
  const canSeeShareButton = policies?.productUpdates._policies.shareProductUpdate.can

  useEffect(() => {
    if (loading) return

    track(trackingEvents.productUpdates.visitProductUpdatesPage, {
      upsell_origin: queryParams.get('upsell_origin'),
      allowed_to_see_subscribe_button: canSeeSubscribeButton,
      allowed_to_see_upsell_button: canSeeUpsellButton,
      allowed_to_see_share_button: canSeeShareButton,
    })
  }, [loading])

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <ResponsivePage.Body variant="wide" showHeader={false}>
        <Box width="full" gap="s32" alignSelf="center" style={{ maxWidth: '1200px' }}>
          <NewLayoutContent
            upsellOrigin={queryParams.get('upsell_origin')}
            canSeeSubscribeButton={canSeeSubscribeButton || false}
            canSeeUpsellButton={canSeeUpsellButton || false}
            canSeeShareButton={canSeeShareButton || false}
          />
        </Box>
      </ResponsivePage.Body>
    </>
  )
}

export default ProductUpdatesPage
